// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__23mm6","header":"MessagesList_header__3WWe2","chat":"MessagesList_chat__1HyQi"};